"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requiresUpdateToFontFamily = void 0;
const requiresUpdateToFontFamily = (oldLayer, newLayer) => {
  var _a, _b, _c, _d;
  const oldFontFamily = (_b = (_a = oldLayer === null || oldLayer === void 0 ? void 0 : oldLayer.defaultData) === null || _a === void 0 ? void 0 : _a.styleRestrictions) === null || _b === void 0 ? void 0 : _b.fontFamily;
  const newFontFamily = (_d = (_c = newLayer === null || newLayer === void 0 ? void 0 : newLayer.defaultData) === null || _c === void 0 ? void 0 : _c.styleRestrictions) === null || _d === void 0 ? void 0 : _d.fontFamily;
  if (!newFontFamily) {
    return false;
  }
  if (Array.isArray(newFontFamily)) {
    if (!Array.isArray(oldFontFamily)) {
      return true;
    }
    const arrayLengthMatches = newFontFamily.length === (oldFontFamily === null || oldFontFamily === void 0 ? void 0 : oldFontFamily.length);
    if (arrayLengthMatches && newFontFamily.every(newFont => oldFontFamily === null || oldFontFamily === void 0 ? void 0 : oldFontFamily.some(oldFont => oldFont === newFont))) {
      return false;
    }
    return true;
  } else {
    return oldFontFamily !== newFontFamily;
  }
};
exports.requiresUpdateToFontFamily = requiresUpdateToFontFamily;